import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Box } from '~Styles';
import useI18n from '~Translations';

const DividerContainer = styled(Box)`
  width: 100%;
  margin: 16px 0;
`;

const DividerLine = styled.hr`
  flex: 1;
  border: none;
  border-top: 1px solid var(--colorBlueGray1000);
  margin: 0 10px;
`;

const DividerText = styled.p`
  margin: 0;
  white-space: nowrap;
  color: #aeb9c8;
`;

/* Used to divide regular orders vs. pre-orders that is later due than 30min */
const DueLaterDivider: FC = () => {
  const { i18n } = useI18n();

  return (
    <DividerContainer display="flex" alignItems="center" padding="medium">
      <DividerLine />
      <DividerText>{i18n('KDS.LaterThan30Minutes')}</DividerText>
      <DividerLine />
    </DividerContainer>
  );
};

export default DueLaterDivider;
